/*
 * @Author: Merlin
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Gaho
 * @LastEditTime: 2024-01-25 10:36:26
 * @Description: 
 */
import type { ICoinFlip } from './dto/index.dto';
import { useAmountMemoryStore } from '~/stores/cansino/amountMemory';
export const useCoinFlip = (rootPath) => {
    const EMIT_COINTFLIP_BET = (
        data: ICoinFlip,
        callback: any,
    ) => {
        const amountMemory = useAmountMemoryStore();
        if (data.amount) {
            amountMemory.setLastAmount(data.amount);
        }
        socket.emit(`${rootPath}.coinflip.bet`, data, callback);
    };

    const EMIT_COINFLIP_JOIN = (data: any, callback: any) => {
        socket.emit(`${rootPath}.coinflip.join`, data, callback);
    };

    return {
        EMIT_COINTFLIP_BET,
        EMIT_COINFLIP_JOIN,
    };
};
